module.exports = __webpack_public_path__ + "banner_iphone18_mass_800x400.ca4646e4.png";